import type { FaireProductEntity } from "../../entity_types/product";

export const p_jvp997585v: FaireProductEntity = {
  token: "p_jvp997585v",
  type: "product",
  name: "Striped Hooded Knit Cardigan",
  brandToken: "b_434zfwvrgm",
  brandName: "Ekartini",
  imageUrl:
    "https://cdn.faire.com/fastly/d62b260966a3d6bc72d2e9deae7d4d215353eb9985e8c03329abf10ea69e2050.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ff416da27d92674764815ab2375f88f272e5d0ae10a03e385f3df77b5c812f67.jpeg",
    "https://cdn.faire.com/fastly/8654ebb931ccdd0c04d46211a62008cc6045742d889b9082ceea72a03e81baac.jpeg",
    "https://cdn.faire.com/fastly/a258963a642ebfd58c6d86e6020e0fbfe52514568e24876c7809df03eedf2b3b.jpeg",
    "https://cdn.faire.com/fastly/804f00559e9c4f1e1e27365368c12cba65a9cbd99bec135d0e1411cf43e4c80c.jpeg",
  ],
  priceDollars: 24.49,
  description:
    "Material:Spandex\n\nStyle:Cute,Intellectual,All-match,Look-younger\n\nFeature:Hooded,Striped,Zipper\n\nNeckline:Hooded\n\nOccasion:Going out,Casual,Artistic Retro,Girlish Sweetness,Light Maturity,Leisure Fashion\n\nSeasons:Spring,Autumn,Winter\n\nType:Sweater\n\nSleeve Length:Long Sleeve\n\nSleeve Style:Raglan Sleeve\n\nSize One_size (inch) : Bust= 35.88 ; Shoulder= 16.38 ; Sleeve= 23.40 ; Length= 20.67 ; \n",
  tags: [],
  msrpDollars: 48.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:56.257Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
